<template>
	<div class="selected-client">
		<app-icon
			class="selected-client__filter-icon"
			name="filter"
			size="14px"
			color="#979797"
		/>
		<span class="selected-client__name">{{ client.Name }}<span
				v-if="client.UseUnion"
				class="selected-client__holding"
			> (с холдингом)</span></span>

		<app-resizable-dropdown
			v-if="roleEditable"
			ref="$roleDropdownRef"
			position="right"
			:close-by-click-outside="true"
			:max-width="400"
			:max-height="436"
			name="$dropdownSelectedClientRole"
		>
			<template #activator>
				<app-icon
					class="selected-client__hash"
					name="hash"
					size="16px"
					color="#979797"
					hover-color="#499259"
					cursor="pointer"
					title="Привязать роль"
				/>
			</template>
			<project-client-role-dropdown
				:client-id="client.Id"
				:attached-roles="client.Roles"
				@change="emit('change')"
			/>
		</app-resizable-dropdown>

		<span
			v-for="role in client.Roles"
			:key="role.Id"
			class="selected-client__role"
		>
			{{ role.Name }}
			<app-icon
				class="selected-client__role-delete"
				name="close-bold"
				size="12px"
				color="#D2D2D2"
				hover-color="#4D4D4D"
				cursor="pointer"
				@click.stop="onRemoveRole(role.Id)"
			/>
		</span>

		<app-icon
			v-if="removable"
			class="selected-client__delete"
			name="close-bold"
			size="12px"
			color="#D2D2D2"
			hover-color="#4D4D4D"
			cursor="pointer"
			@click.stop="emit('remove')"
		/>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import ProjectClientRoleDropdown from "@/components/main/search-panel/dropdowns/ProjectClientRoleDropdown.vue";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { searchStore } from "@/store/search";

const props = withDefaults(defineProps<{
	client: { Id: number, Name: string, UseUnion?: boolean, Roles: CommonEntityRecord[] },
	roleEditable?: boolean,
	removable?: boolean,
}>(), {
	roleEditable: true,
	removable: true,
})

const emit = defineEmits(['remove', 'change'])

const store = searchStore()

const $roleDropdownRef = ref<typeof AppResizableDropdown | null>(null)

const onRemoveRole = (roleId: number) => {
	store.detachRoleFromSelectedClient(props.client.Id, roleId)
	emit('change')
}
</script>

<style scoped lang="scss">
.selected-client {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 4px;

	&__filter-icon {
		flex-shrink: 0;
	}

	&__name {
		color: #4D4D4D;
		font-size: 14px;
		line-height: 18px;
	}

	&__holding {
		color: #979797;
	}

	&__hash {
		flex-shrink: 0;
	}

	&__role {
		display: inline-flex;
		align-items: center;
		gap: 2px;
		color: #979797;
		font-size: 14px;
		line-height: 18px;
	}

	&__delete {
		flex-shrink: 0;
	}
}
</style>
